/**
 * 시간 계산 관련 유틸 함수 모듈
 * @module core/time/calculate
 */
import dayjs, { Dayjs } from 'dayjs';
import { MIN_DATE_TIME, GLOBAL_TIME_RANGE_FORMAT } from './constants';

/**
 * 최소 날짜보다 이전인 경우 최소 날짜 반환
 * @param time dayjs 객체
 * @returns 안전한 dayjs 객체
 */
export const getSafeDateTime = (time: Dayjs): Dayjs => {
  const minDateTime = dayjs(MIN_DATE_TIME);
  return time.isValid() && time.utc().isAfter(minDateTime.utc()) ? time : minDateTime;
};

/**
 * 두 시간의 차이를 초 단위로 계산
 * @param fromTime 시작 시간
 * @param toTime 종료 시간
 * @returns 차이 (초)
 */
export const getDiffSecond = (fromTime: string, toTime: string): number => {
  const fromTimeParsed = dayjs(fromTime, GLOBAL_TIME_RANGE_FORMAT);
  const toTimeParsed = dayjs(toTime, GLOBAL_TIME_RANGE_FORMAT);

  return toTimeParsed.diff(fromTimeParsed, 's');
};

/**
 * epoch ms를 다음 초(秒) 경계로 올림
 * - 정수 초(ms = 0)는 변경 없음
 * - 0 < ms ≤ 999는 다음 초로 올림
 * @example
 * ceilToSecond(37_000) // 37_000
 * ceilToSecond(37_001) // 38_000
 * ceilToSecond(37_500) // 38_000
 * @param ms epoch milliseconds
 * @returns 초 경계로 올림된 epoch ms
 */
export const ceilToSecond = (ms: number): number => Math.ceil(ms / 1000) * 1000;
